import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconPrev = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0.219103 7.54628L6.33525 13.7763C6.47671 13.9206 6.66555 14 6.8669 14C7.06825 14 7.25709 13.9206 7.39854 13.7763L7.84896 13.3176C8.14204 13.0188 8.14204 12.533 7.84896 12.2345L2.71307 7.0029L7.85466 1.76547C7.99612 1.62126 8.07422 1.42901 8.07422 1.22402C8.07422 1.01881 7.99612 0.826563 7.85466 0.682239L7.40424 0.223657C7.26267 0.0794464 7.07395 -8.74464e-08 6.8726 -1.05049e-07C6.67125 -1.22652e-07 6.48241 0.0794463 6.34095 0.223657L0.219104 6.45941C0.0773092 6.60408 -0.000571253 6.79723 -0.000124323 7.00256C-0.000571289 7.20869 0.0773091 7.40173 0.219103 7.54628Z"
                fill={color}/>
        </svg>
    </div>
);

export default IconPrev;
